import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Card, CardBody, Row, Col
} from 'reactstrap';
import { TextField } from '../../../shared/TextField';
import { PRODUCT_GROUPS } from '../../../../config/constants';
import {
  calculateTotalPriceOnCustomOrderWithoutVat, getCustomOrderProduct
} from '../../../../helpers/general';
import { Messages } from '../../../layout/Messages/Messages';
import { ErrorMessage } from 'formik';

function QualifiedSignaturesFields(props) {
  const getCurrencyOfProduct = () => {
    let productGroup;
    props.productGroups.forEach( item => {
      if (item.name === PRODUCT_GROUPS.QUALIFIED_SIGNATURE.name) {
        productGroup = item;
      }
    } );

    return getCustomOrderProduct(productGroup).currency;
  }

  const calculateTotalPrice = () => {
    if (isNaN( props.formikProps.values.qualifiedSignaturesNumber ) || isNaN( props.formikProps.values.qualifiedSignaturesValue )) {
      return `0 ${getCurrencyOfProduct()}`;
    }

    return `${calculateTotalPriceOnCustomOrderWithoutVat( props.formikProps.values.qualifiedSignaturesNumber, props.formikProps.values.qualifiedSignaturesValue )} ${getCurrencyOfProduct()}`
  }

  return (
    <Card id="create-order-qualified-signatures-content">
      <CardBody>
        <Row className="align-items-center mb-3">
          <Col xs={12} sm={3}>
            <FormattedMessage
              id="components.pages.orderManagement.selectProductGroup.simple_signatures.number"/>
          </Col>
          <Col xs={12} sm={9}>
            <TextField
              name="create_order.number"
              value={props.formikProps.values.qualifiedSignaturesNumber}
              classNameFormGroup="m-0"
              onChange={(e) =>
                props.formikProps.setFieldValue( "qualifiedSignaturesNumber", e.target.value )
              }
              errorClass={props.getErrorClass( props.formikProps, 'qualifiedSignaturesNumber' )}
            />
            <Messages
              color="danger"
              formikProps={props.formikProps}
              class="small-field-error"
              showDismiss={false}
            >
              <ErrorMessage
                name="qualifiedSignaturesNumber"
                component="div"
                data-testid="errors-qualifiedSignaturesNumber"
                className="field-error"
              />
            </Messages>
          </Col>
        </Row>
        <Row className="align-items-center mb-3">
          <Col xs={12} sm={3}>
            <FormattedMessage
              id="components.pages.orderManagement.selectProductGroup.simple_signatures.price"/>
          </Col>
          <Col xs={12} sm={9}>
            <TextField
              name="create_order.value"
              value={props.formikProps.values.qualifiedSignaturesValue}
              classNameFormGroup="m-0"
              onChange={(e) =>
                props.formikProps.setFieldValue( "qualifiedSignaturesValue", e.target.value )
              }
              errorClass={props.getErrorClass( props.formikProps, 'qualifiedSignaturesValue' )}
            />
            <Messages
              color="danger"
              formikProps={props.formikProps}
              class="small-field-error"
              showDismiss={false}
            >
              <ErrorMessage
                name="qualifiedSignaturesValue"
                component="div"
                data-testid="errors-qualifiedSignaturesValue"
                className="field-error"
              />
            </Messages>
          </Col>
        </Row>
        <Row className="create-order-total-val">
          <FormattedMessage
            id="components.pages.orderManagement.selectProductGroup.simple_signatures.sub_total"/> {calculateTotalPrice()}
        </Row>
      </CardBody>
    </Card>
  );
};


export { QualifiedSignaturesFields };
